
import logo from "../logo.png";

function About(args) {

    return (
    <div style={{backgroundColor:"#17181b",width :"100vw",height:"100vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
      <a href="/" className="logo" style={{width:"15rem"}}><img src={logo} alt="logo" style={{height:"100%",width:"100%"}}/></a>
       <h2>Biz Tua Astro Hackathon yarışması için kurulmuş liseli bir grubuz. Derin uzay iletişiminde verilerin en az kayıplı ve en hızlı şekilde iletilmesi için MiniBit adında yeni bir algoritma geliştirdik. Bu algoritmamızla beraber verilerin kayıpsız olarak daha hızlı ve daha verimli sıkıştırılmasını sağlayacağız.</h2>
    </div>
    )
} 

export default About;